import { render, staticRenderFns } from "./NoticeNav.vue?vue&type=template&id=d48bef08&scoped=true&"
import script from "./NoticeNav.vue?vue&type=script&lang=js&"
export * from "./NoticeNav.vue?vue&type=script&lang=js&"
import style0 from "./NoticeNav.vue?vue&type=style&index=0&id=d48bef08&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d48bef08",
  null
  
)

export default component.exports